import React, { useEffect, useState } from "react";
import { Box, DialogActions, DialogContent, Tooltip, Typography } from "@mui/material";
import TextInputComponent from "../../atom/Inputs/TextInput";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import DropDownComponent from "../../atom/Inputs/DropDown";
import { connect, useDispatch } from 'react-redux';
import { Actions } from "../../../core/modules/Actions";
import { EMAIL_REGEX, THEME_COLORS } from "../../../core/Constant";
import { useLocation } from "react-router-dom";
import { PhoneNumberComponent, RadioButtonComponent } from "../../atom";
import { parsePhoneNumber, isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input'
import _ from "lodash";
import moment from "moment";



const AddStudentForm = ({ onclickcancel, dropdownList, getCourseMainDetails, mainDetailsState }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [studentFormData, setStudentFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        course_id: "",
        course_plan_type_id:""
    });
    const [errors, setErrors] = useState({
        first_name: "",
        last_name: "",
        email: "",
        course_id: "",
        course_plan_type_id:""
    });

       const [phone, setPhone] = useState('');
        const [isPhoneValid, setIsPhoneValid] = useState(false);
        const [phoneError, setPhoneError] = useState(false);
        const [countryCode, setCountryCode]=useState("+1");

    const emptyFormfields = () => {
        setStudentFormData({
            first_name: "",
            last_name: "",
            email: "",
            course_id: "",
            course_plan_type_id:""
        })
        setPhone('')
        setCountryCode('+1')
    }

    const validateForm = () => {
        const newErrors = {
            first_name: "",
            last_name: "",
            email: "",
            course_id: "",
            course_plan_type_id:""
        };
        const reg = EMAIL_REGEX;

        if (!studentFormData?.first_name.trim()) {
            newErrors.first_name = "First Name is required";
        }

        if (!studentFormData?.last_name.trim()) {
            newErrors.last_name = "Last Name is required";
        }

        if (!studentFormData?.email.trim()) {
            newErrors.email = "Email is required";
        }
        else if (!reg.test(studentFormData?.email.trim())) {
            newErrors.email = "Invalid email format";
        }
        if (!studentFormData?.course_id) {
            newErrors.course_id = "Course is required";
        }
        if (mainDetailsState?.is_free === 0 && studentFormData?.course_id && !studentFormData?.course_plan_type_id ) {
            newErrors.course_plan_type_id = "Plan is required";
        }
        if (!isPhoneValid) {
            setPhoneError(true)

        }

        setErrors(newErrors);

        // Return true if there are no errors
        return Object.values(newErrors).every(error => !error);
    }

    const handleChange = async (name, value) => {
        if(name === "course_id"){
           setErrors((prevState)=> ({ ...prevState, course_plan_type_id:""  }));       
           getCourseMainDetails({
              id: value,
           });
        }
        setErrors((prevState)=> ({ ...prevState, [name] :""  }));
        setStudentFormData({
            ...studentFormData,
            [name]: value,
            ...(name === "course_id" && {
                  course_plan_type_id: "",
            }),
        });
    }

      const onPhoneChange = (text) => {
            setPhone(text);
            let isValid = false;
            if (text?.length > 3) {
                //  isValid = PHONE_REGEX.test(text.trim());
                const phoneData= parsePhoneNumber(text)
                isValid = isPossiblePhoneNumber(text) && isValidPhoneNumber(text);
                setCountryCode(`+${_.get(phoneData,"countryCallingCode")}`)
            }
    
            setIsPhoneValid(isValid);
            setPhoneError(false)
        }
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            dispatch(Actions.students.createAdminStudent({
                first_name: studentFormData?.first_name,
                last_name: studentFormData?.last_name,
                email: studentFormData?.email,
                course_id:studentFormData?.course_id,
                course_currency_id: studentFormData?.course_plan_type_id,
                whatsapp_country_code:countryCode,
                whatsapp_phone_number:phone,
                phone_number:phone,
                currency_id:"1"
            }));
            onclickcancel();
            emptyFormfields();
        }
    };

    useEffect(()=>{
        if(mainDetailsState?.is_free === 1){
           const course_currency = mainDetailsState?.course_currencies?.[0]
           const course_currency_id = course_currency?.id || ""
           setStudentFormData((prevState)=>{
             return {
                ...prevState, 
                course_plan_type_id: course_currency_id?.toString(),
             }
           })
        } else {
            setStudentFormData((prevState)=>{
             return {
                ...prevState, 
                course_plan_type_id: "",
             }
           })
        }
    },[mainDetailsState])

    return (
        <>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    <Box>
                        <TextInputComponent
                            label={"First Name"}
                            placeholder="First Name"
                            name="first_name"
                            value={studentFormData?.first_name}
                            onchange={(e) => handleChange('first_name', e.target.value)}
                            isError={errors.first_name !== "" ? true : false}
                            error={errors?.first_name}
                        />


                        <TextInputComponent
                            label={"Last Name"}
                            name="last_name"
                            value={studentFormData.last_name}
                            onchange={(e) => handleChange('last_name', e.target.value)}
                            placeholder="Last Name"
                            isError={errors.last_name !== "" ? true : false}
                            error={errors?.last_name}

                        />

                        <TextInputComponent
                            label={"Email"}
                            value={studentFormData.email}
                            placeholder="Email"
                            name="email"
                            onchange={(e) => handleChange('email', e.target.value)}
                            isError={errors.email !== "" ? true : false}
                            error={errors?.email}
                        />
                           <PhoneNumberComponent
             label={"WhatsApp/Phone Number"}
             name="phoneNumber"
             value={phone}
             placeholder="WhatsApp/Phone Number"
             onChange={onPhoneChange}
             defaultCountry="CA"
             readOnly={false}
             isError={phoneError}
             error={'Please add valid WhatsApp/phone number'}
            />

                       <DropDownComponent
                            isError={errors.course_id !== "" ? true : false}
                            error={errors?.course_id}
                            isShowZero={false}
                            onchange={(e) => handleChange('course_id', e.target.value)}
                            selectedValue={studentFormData.course_id}
                            list={dropdownList}
                            dropdownLabel="Course"
                            fixedWidth="100%"
                            enableTooltip={true}
                             />
                             <Box sx={{ width:"100%", p:1 }}>
                            <Box sx={{
                               bgcolor: THEME_COLORS.gray4,
                               borderRadius: 2,
                            }}>
                            {
                               studentFormData.course_id && mainDetailsState?.is_free === 0 && mainDetailsState?.course_currencies?.map((plan)=>{

                                 const planName = plan?.plan_name
                                 const needsTooltip = planName?.length > 40
                                 const displayedText = needsTooltip
                                    ? `${planName?.substring(0, 40)}...`
                                    : planName;
                                 return (
                                <Box >
                                <Box display={"flex"} alignItems={"center"}>
                                <RadioButtonComponent 
                                 checked={plan?.id?.toString() === studentFormData?.course_plan_type_id?.toString()} 
                                 selectedValue={ plan?.id === studentFormData?.course_plan_type_id } 
                                 value={plan?.id} 
                                 handleChange={(e)=>{
                                    handleChange('course_plan_type_id', e.target.value)
                                 }} 
                                />
                                <Box >
                                    <span
                                      style={{
                                        fontFamily: "Montserrat, sans serif",
                                        fontSize: "15px",
                                        padding: 0,
                                        margin: 0,
                                        marginRight:5,
                                        color:"#2d3945"
                                      }}
                                    >
                                      {needsTooltip ? (
                                         <Tooltip title={planName} placement="top" arrow>
                                           <span style={{ cursor: "pointer" }}>
                                             {displayedText}
                                           </span>
                                         </Tooltip>
                                       ) : (
                                         displayedText
                                       )}  
                                    </span>
                                
                                      <span
                                        style={{
                                          fontFamily: "Montserrat",
                                          fontWeight: 800,
                                          fontSize: 15,
                                          color: "#2d3945",
                                        }}
                                      >
                                        { planName ? " -" : "" }
                                        {`${plan?.batch_month ? moment()
                                          .month(Number(plan?.batch_month) - 1)
                                          .format("MMMM") : "" } ${plan?.batch_year ? plan?.batch_year : ""}`}
                                      </span>
                                    </Box>
                                </Box>
                                 </Box>
                                 )
                                })
                            }
                            {errors?.course_plan_type_id ? <p style={{ marginLeft:10 }} className="input-error-text">{errors?.course_plan_type_id}</p> : null} 
                           </Box>  
                           </Box>      
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Box sx={{ display: "flex", width: "50%", mr: 2.2, mb: 2, ml: 2.2 }}>
                        <Box sx={{ display: "flex", gap: 0.5, flexGrow: 1 }}>
                            <Box sx={{ flexGrow: 1 }}>
                                <TextButtonComponet text="Add" classStyle="btn btn-primary"
                                    onButtonClick={handleSubmit}
                                />
                            </Box>
                            <Box sx={{ flexGrow: 1 }}>
                                <TextButtonComponet text="Cancel" classStyle="btn btn-secondary" onButtonClick={() => {
                                    onclickcancel(); emptyFormfields(); setErrors({
                                        first_name: "",
                                        last_name: "",
                                        email: "",
                                        course_id: ""
                                    });
                                }} />
                            </Box>
                        </Box>

                    </Box>
                </DialogActions>

            </form>

        </>
    );
}

export default connect(
  (state) => ({
    mainDetailsState: state.course.get("mainDetailsState"),
  }),
  {
    getCourseMainDetails: Actions.course.getCourseMainDetails,
  }
)(AddStudentForm);